const ANDROID_USER_AGENT_PATTERN = /Android/i;
const ANDROID_WEBVIEW_USER_AGENT_PATTERN =
  /;\s*wv\)|\bVersion\/4\.0\b.*\bChrome\/\d+/i;
const LINE_USER_AGENT_PATTERN = /\bLine(?:\/|\s|$)/i;

export const SPARTAN_PRODUCT_ANDROID_LINE_CLASS =
  'spartan-product-android-line';

/** LINE can expose only the generic Android WebView UA on some devices. */
export const shouldUseAndroidProductScrollFallback = (
  userAgent: string
): boolean =>
  ANDROID_USER_AGENT_PATTERN.test(userAgent) &&
  (LINE_USER_AGENT_PATTERN.test(userAgent) ||
    ANDROID_WEBVIEW_USER_AGENT_PATTERN.test(userAgent));
